// extracted by mini-css-extract-plugin
module.exports = {"sharingItems":"SharingItems_sharingItems__PFS78"};